import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const AlertType = { S: 'success', W: 'warning', I: 'info', E: 'error' };

export default function MsgBox(props: any) {
  const [open, setOpen] = React.useState(props.open);
  const { t } = useTranslation();
  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open, props.toogle])
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  let el = <></>;
  if (props.msg === undefined) {
    return el;
  }
  switch (props.type) {
    case AlertType.S:
      el = <Alert severity="success">{t(props.msg)}</Alert>
      break;
    case AlertType.E:
      el = <Alert severity="error">{t(props.msg)}</Alert>
      break;
    case AlertType.W:
      el = <Alert severity="warning">{t(props.msg)}</Alert>
      break;
    case AlertType.I:
      el = <Alert severity="info">{t(props.msg)}</Alert>
      break;
    default:
      break;
  }
  return <Snackbar anchorOrigin={{vertical: 'top', horizontal: 'right'}} open={open} autoHideDuration={6000} onClose={handleClose}>{el}</Snackbar>;
}